import React from "react";
import { styled } from "@mui/material/styles";
import { Grid, Box, Typography, useTheme, useMediaQuery } from '@mui/material';

const MainContainer = styled(Box)({
    minHeight: "500px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    overflow: "hidden",
    "@media (max-width: 960px)": { // Tablet and below
        minHeight: "100%",
    },
});

const VideoWrapper = styled(Box)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    overflow: "hidden",
    zIndex: 0,
    "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "linear-gradient(90deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 90.68%),linear-gradient(90deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 85.52%),linear-gradient(90deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%)",
        zIndex: 1, // Overlay above video
    }
});

const VideoBackground = styled("video")({
    width: "100%",
    height: "100%",
    objectFit: "initial",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 0, // Keep it below the gradient overlay
});

const ContentWrapper = styled(Box)({
    position: 'relative',
    width: "100%",
    maxWidth: "1200px",
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    zIndex: 1, // Places content above the video
    margin: '0 auto',
    padding: '16px',
});

const IndustriesFeaturelistSection = ({ data, backgroundItem }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <MainContainer>
            <VideoWrapper>
                <VideoBackground autoPlay loop muted src={backgroundItem}
                    sx={{ width: "100%", height: "100%" }}>
                </VideoBackground>
            </VideoWrapper>
            <ContentWrapper>
                <Grid container spacing={2} alignItems="left">
                    <Grid item xs={12} md={6}>
                        <Typography sx={{
                            color: "#FFFFFF",
                            fontSize: 24,
                            fontWeight: 700,
                            lineHeight: 1.6,
                            mb: 2
                        }}>
                            {data?.listTitle}
                        </Typography>


                        {data?.listItems?.length === 0 ?
                            <>
                                <Box sx={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "space-around", gap: 2 }}>
                                    {data?.listSubTitle?.map((item, index) => (
                                        <Typography sx={{
                                            color: "#8C8CC2",
                                            fontSize: 16,
                                            fontWeight: 400,
                                            lineHeight: 1.6,
                                            mb: 2
                                        }}>
                                            {item}
                                        </Typography>
                                    ))}
                                </Box>
                            </>
                            :
                            <>
                                <Typography sx={{
                                    color: "#8C8CC2",
                                    fontSize: 16,
                                    fontWeight: 400,
                                    lineHeight: 1.6,
                                    mb: 2
                                }}>
                                    {data?.listSubTitle}
                                </Typography>
                                <Box sx={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "space-around", gap: 2 }}>
                                    {data?.listItems?.map((item, index) => (
                                        <Box key={index} sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 2,
                                            color: "#8C8CC2",
                                            fontSize: { xs: 14, md: 16 }
                                        }}>
                                            <Typography sx={{ fontSize: { xs: 14, md: 16 } }}>•</Typography>
                                            <Typography>{item}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </>
                        }
                    </Grid>
                </Grid>
            </ContentWrapper>
        </MainContainer>
    );
};

export default IndustriesFeaturelistSection;
